export enum OutlookSyncStatus {
  Enqueued = 1,
  Syncing = 2,
  Complete = 3,
  Warning = 4,
  Problem = 5,
}

export enum CustomOutlookSyncStatus {
  Paused = 6,
  NoPermission = 7,
}

export type ExtendedOutlookSyncStatus =
  | OutlookSyncStatus
  | CustomOutlookSyncStatus;

export type OutlookSyncProblemCode =
  | 100
  | 101
  | 102
  | 103
  | 200
  | 201
  | 202
  | 203
  | 204
  | 300
  | 301
  | 302
  | 303
  | 400
  | 401
  | 402
  | 500;

export interface SyncHealthStatus {
  isMaximizerAuthHealthy: boolean;
  isMicrosoftAuthHealthy: boolean;
  isConfigurationEnabled: boolean;
  isContactsSyncEnabled: boolean;
  isTasksSyncEnabled: boolean;
  isAppointmentsSyncEnabled: boolean;
  isEmailsSyncEnabled: boolean;
  isEmailsSyncEverythingEnabled: boolean;
  isIncomingEmailsSyncEnabled: boolean;
  isOutgoingEmailsSyncEnabled: boolean;
}
